// extracted by extract-css-chunks-webpack-plugin
module.exports = {"gallery":"image-gallery__gallery--2KYOC","image-thumb":"image-gallery__image-thumb--33YT8","imageThumb":"image-gallery__image-thumb--33YT8"};